const ArrowLeftIcon = () => {
  return (
    <svg
      width='12'
      height='9'
      viewBox='0 0 12 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.2174 3.67298L2.88077 3.67298L5.30808 1.45056C5.63468 1.15161 5.67057 0.629959 5.38757 0.284995C5.10449 -0.0599694 4.60957 -0.0968442 4.28295 0.202125L0.270041 3.87531L0.208899 3.93773C0.0754114 4.08967 8.5942e-05 4.29007 0 4.49952C0 4.73924 0.0985223 4.96782 0.270041 5.12482L4.28295 8.798L4.34613 8.84966C4.67059 9.09104 5.12203 9.03859 5.38757 8.71513C5.65294 8.39175 5.63809 7.91264 5.36617 7.60769L5.30808 7.54849L2.87976 5.32607L11.2174 5.32607C11.6496 5.32607 12 4.95601 12 4.49952C11.9998 4.0432 11.6495 3.67298 11.2174 3.67298Z'
        fill='#317FF5'
      />
    </svg>
  );
};

export default ArrowLeftIcon;
